var map = {
	"./Element.svg": "1a40",
	"./Exit.svg": "cb34",
	"./Sale.svg": "2612",
	"./Team.svg": "032c",
	"./Vector.svg": "7197",
	"./account-logout-white.svg": "31f1",
	"./account-logout.svg": "96b8",
	"./address.svg": "7525",
	"./ai.svg": "e163",
	"./alert.svg": "e0ac",
	"./area.svg": "6b9d",
	"./arrow-but.svg": "6a72",
	"./arrow-footer.svg": "2f42",
	"./arrow-right.svg": "0135",
	"./arrow_down.svg": "428b",
	"./attention.svg": "1da8",
	"./avatar-white.svg": "3ed4",
	"./avatar.svg": "7f18",
	"./bg_circle.svg": "4dd9",
	"./big-cross.svg": "cb9d",
	"./burger-dark.svg": "9c4f",
	"./burger.svg": "700c",
	"./burger_white.svg": "997f",
	"./cabinet.svg": "5816",
	"./calendar-grey.svg": "7e2e",
	"./calendar-light.svg": "0ced",
	"./calendar-transparrent.svg": "f0a2",
	"./calendar.svg": "5968",
	"./carona-19.svg": "4d56",
	"./changeGameSeasonQuestionMark.svg": "336f",
	"./check-circle.svg": "e0c1",
	"./clock-transparrent.svg": "2e34",
	"./clock.svg": "1caf",
	"./copy-link-brand.svg": "7ce9",
	"./copy-link.svg": "3bd7",
	"./copy.svg": "2937",
	"./cross-partners.svg": "bd46",
	"./cross-tuts.svg": "0c32",
	"./cross.svg": "9b37",
	"./discount.svg": "e7fc",
	"./dot.svg": "616b",
	"./dotes-menu.svg": "55de",
	"./download-data-base.svg": "e431",
	"./download-data-white.svg": "ebe9",
	"./download.svg": "8c27",
	"./emozgo.svg": "90da",
	"./error_notification.svg": "db54",
	"./exclamation-mark.svg": "913f",
	"./exclimation-mark.svg": "5062",
	"./facebook.svg": "0a56",
	"./fb.svg": "6ae7",
	"./fill.svg": "62a9",
	"./fill_1.svg": "e3d3",
	"./fill_1_black.svg": "1467",
	"./fill_1_white.svg": "cad0",
	"./fill_3.svg": "4f66",
	"./fire-block-white.svg": "1453",
	"./footer_logo.svg": "5fe9",
	"./franchise_circle.svg": "6be7",
	"./franchise_circle_transparent.svg": "b9ce",
	"./galochka.svg": "6b0e",
	"./gear.svg": "aa9a",
	"./gps-transparrent.svg": "7f64",
	"./gps.svg": "87c6",
	"./have-comment.svg": "454e",
	"./heading.svg": "f0ec",
	"./home-arrow.svg": "f607",
	"./home-page-mobile-bg-image.svg": "1ff4",
	"./instagram.svg": "c0d3",
	"./loader-results.svg": "5896",
	"./location.svg": "5557",
	"./logo.svg": "7316",
	"./logo_black.svg": "9090",
	"./logo_stub.svg": "c47d",
	"./logo_white.svg": "30b2",
	"./looppa.svg": "b8d1",
	"./main-cup.svg": "bb4ab",
	"./main-page-rating-section-arrow-down.svg": "c8e0",
	"./main_background_city_offlineGame_mobile.svg": "42eb",
	"./minus.svg": "877a",
	"./mobile-menu.svg": "7789",
	"./mobile-profile-logo-black.svg": "5668",
	"./mobile-profile-logo-white.svg": "724a",
	"./modal-tick.svg": "781d",
	"./money-grey.svg": "ad02",
	"./money-light.svg": "58f7",
	"./money.svg": "0e9b",
	"./mozgo-logo-vote.svg": "ad7e",
	"./mozgo-logo.svg": "45cb",
	"./mozgo_logo_text.svg": "60ff",
	"./mozgo_logo_text_white.svg": "5186",
	"./new_team.svg": "40a6",
	"./next-button.svg": "94b3",
	"./next.svg": "d26b",
	"./nextArrow.svg": "3020",
	"./no-comment.svg": "78e3",
	"./online-game-arrow.svg": "4aa4",
	"./pencil.svg": "db2c",
	"./pencil_brand.svg": "751f",
	"./place-black.svg": "4282",
	"./place.svg": "bd9c",
	"./place1.svg": "9470",
	"./plus.svg": "3171",
	"./poc.svg": "81d4",
	"./prev-button.svg": "ff68",
	"./price-transparrent.svg": "6621",
	"./price.svg": "8496",
	"./price1.svg": "87f9",
	"./promo-code-error-icon.svg": "2464",
	"./promocode-applied-icon.svg": "4bbf",
	"./psd.svg": "2a9b",
	"./quotes.svg": "d86d",
	"./rating-background-mobile.svg": "0a3f",
	"./rating-background.svg": "1b0b",
	"./rating-page-text-mobile.svg": "8765",
	"./rating-page-text.svg": "700d",
	"./rating-rang-1.svg": "a08a",
	"./rating-rang-2.svg": "b40d",
	"./rating-rang-3.svg": "eb54",
	"./rating-rang-4.svg": "b814",
	"./rating-rang-5.svg": "1e2a",
	"./rating-rang-6.svg": "e1c5",
	"./rating-star.svg": "9058",
	"./rating-video-play-button.svg": "fe90",
	"./ratingStatisticIcon.svg": "cfa3",
	"./right.svg": "f852",
	"./search.svg": "52bc",
	"./snow.svg": "6bdd",
	"./sort.svg": "69ec",
	"./special-game-card-mozgo-logo.svg": "c62b",
	"./step4_plus.svg": "4371",
	"./tail-spin-results.svg": "3257",
	"./tail-spin.svg": "2b5f",
	"./test.svg": "91f9",
	"./tick.svg": "fdd6",
	"./tick_white.svg": "ad93",
	"./time-grey.svg": "02b5",
	"./time-light.svg": "f0e5",
	"./time.svg": "19d5",
	"./top-feed-back.svg": "c35d",
	"./trash-1.svg": "d661",
	"./trash-bin-white.svg": "45f5",
	"./trash-bin.svg": "af8c",
	"./uploadResultsIcon.svg": "85ae",
	"./video-banner-background-mobile.svg": "dc22",
	"./video-banner-background.svg": "30a8",
	"./vk.svg": "b6c9",
	"./watch.svg": "3ebd",
	"./watch1.svg": "74e7",
	"./white-cross.svg": "c596",
	"./yellow-point.svg": "d62a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "96bc";